/*
Author: Liubo
Date: 2018-09-05
Desc: Vuex 状态管理模块-模板
*/
import cache from "@/assets/js/cache";
export default {
    state: {
        info: JSON.parse(sessionStorage.getItem("_c") || "{}"),
        qryallfund: ""
    },
    getters: {},
    mutations: {
        SET_INFO (state, val) {
            state.info = Object.assign({}, val || {});
            state.qryallfund = val.qryallfund || "";
            cache.setUser(state.info || {user: "not"});
        }
    },
    actions: {
        setInfo (context, data) {
            context.commit("SET_INFO", data);
        }
    }
};
